// CB:BEGIN useAuthFetch
/**
 * Returns an authenticated fetch function that attaches Clerk Bearer token (or dev token)
 * so backend requireClerkSession sees the user. Use for any /api/* call that requires auth.
 */
import { useCallback } from 'react';
import { useAuth } from '@clerk/clerk-react';

export function useAuthFetch() {
  const { getToken } = useAuth();

  return useCallback(
    async (url: string, init?: RequestInit): Promise<Response> => {
      let token: string | null = null;
      try {
        const devAuth = localStorage.getItem('devAuth');
        if (devAuth) {
          const parsed = JSON.parse(devAuth);
          if (parsed?.isDevelopment && parsed?.token) token = parsed.token;
        }
      } catch {}
      if (!token) token = await getToken();
      const headers = new Headers(init?.headers ?? {});
      if (token) headers.set('Authorization', `Bearer ${token}`);
      if (import.meta.env.DEV) {
        console.log('[authFetch]', url.split('?')[0], { hasAuth: !!token });
      }
      return fetch(url, { ...init, credentials: 'include', headers });
    },
    [getToken]
  );
}
// CB:END useAuthFetch
